import 'es6-promise/auto';
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/string/includes';
import 'element-closest';
import Vue from 'vue';
import cfdCpecification from './components/CfdSpecification.vue';
import store from './store/index.js';
import tipok from 'tipok';

tipok.init({
    html: true
});

/* eslint-disable no-new */
new Vue({
    el: '#cfd-specification',
    store,
    components: {
        'cfd-specification': cfdCpecification
    }
});
/* eslint-enable no-new */



// WEBPACK FOOTER //
// ./src/main.js